import React from "react";
import { appStore } from "../../stores/appStore";

const CountDownTimer = () => {
  // getting data from appStore
  const { countDownTimer } = appStore((state) => ({
    countDownTimer: state.countDownTimer,
  }));

  const totalSeconds = countDownTimer;

  // get number of full minutes
  const minutes = Math.floor(totalSeconds / 60);

  // get remainder of seconds
  const seconds = totalSeconds % 60;

  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  //  format as MM:SS
  const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;

  return (
    <React.Fragment>
      {result}
    </React.Fragment>
  )
}
export default CountDownTimer;